地理分布

<template>
    <div class="distribution_wrap">
        <div class="profile_area">
            <div class="area_select" @click="checkArea">
                <span>{{ selectArea }}</span>
                <img src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
            </div>
            <div class="area_select" @click="checkGrade">
                <span>{{ selectGrade }}</span>
                <img src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
            </div>
        </div>
        <!-- 腾讯地图 -->
        <div class="distribution_map">
            <div id="container_map" class="distribution_map_item"></div>

            <div class="distribution_map_detail" v-if="isShowItem">
                <div class="distribution_map_box">
                    <div class="distribution_map_detail_top">
                        <div class="distribution_map_detail_top_item">
                            <img src="@/assets/resourcesManage/ic_5@3x.png" alt="">
                            <span>五级</span>
                        </div>
                        <div class="distribution_map_detail_top_item">
                            <img src="@/assets/resourcesManage/ic_4@3x.png" alt="">
                            <span>四级</span>
                        </div>
                        <div class="distribution_map_detail_top_item">
                            <img src="@/assets/resourcesManage/ic_3@3x.png" alt="">
                            <span>三级</span>
                        </div>
                        <div class="distribution_map_detail_top_item">
                            <img src="@/assets/resourcesManage/ic_2@3x.png" alt="">
                            <span>二级</span>
                        </div>
                        <div class="distribution_map_detail_top_item">
                            <img src="@/assets/resourcesManage/ic_1@3x.png" alt="">
                            <span>一级</span>
                        </div>
                    </div>
                    <div class="distribution_map_detail_bottom">
                        <div class="distribution_map_detail_bottom_item">
                            <img src="@/assets/resourcesManage/ic_blue_4@2x.png" alt="">
                            <span>自然旅游资源(主类A、B、C、D)</span>
                        </div>
                        <div class="distribution_map_detail_bottom_item">
                            <img src="@/assets/resourcesManage/ic_red_4@2x.png" alt="">
                            <span>人文旅游资源(主类E、F、G、H)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 地文景观 -->
        <common-picker ref="commonpicker" :typeList="typeListCity" :cols="3" @getTypeValue="getSelectArea"></common-picker>
        <!-- 等级 -->
        <common-picker ref="commonpickerGrade" :typeList="typeListGrade" :cols="colsGrade" @getTypeValue="getSelectGrade"></common-picker>
    </div>
</template>

<script>
import api from '../../../../../service/modules/resourcesManage';
import commonPicker from '../../../../components/base/commonPickerTwo';
import crypto from 'crypto'

export default {
    components: {
        commonPicker
    },
    data () {
        return {
            selectArea: '全部类型',
            selectGrade: '全部等级',
            cols: 1,
            colsGrade: 1,
            typeListCity: [],
            isShowItem: true,
            typeListGrade: [],
            // mapList: [],
            mapDataList: [], // 地图数据
            map: null,  // 地图
            markerList: [],
            classifyId: '',
            classifyLevel: '',
            evaluateScoreLevel: '',
            latitude: '',
            longitude: '',
            flag: true,
            md5Value: ''
        }
    },
    async created () {
        // this.CalcuMD5('/ws/location/v1/ip?callback=jsonp_1d0323bf7ae0b60&key=SZMBZ-JCY6P-SKCDS-LFZGI-QC2B7-ZCFYN&output=jsonpBKWF5kwkloKLI1xaJBjvg0wDTQmniMSm');
        // this.getForIP();
        await this.getPercentageClassify();
        await this.getGradeList();
        this.getDirectoriesPositions();
    },

    mounted () {
        /**
         *      zoom:  地图层级
         *      viewMode: 地图2d\3d切换
         *      zoomControl: 缩放控件
         *      showControl: 所有控件的显示隐藏
         *      vectorBaseMap: 仅渲染：道路及底面(base) + 2d建筑物(building2d)，以达到隐藏文字的效果
         */
        if(!window.TMap){
            let time = setInterval(()=> {
                if (window.TMap){
                    console.log('11')
                    clearInterval(time);
                    this.getMap();
                }
            },10)
        }else{
            console.log('22')
            this.getMap();
        }

    },
    watch: {
        // mapDataList (newData, oldData) {
        //     this.init();
        // }
    },
    methods: {
        getMap(){
            this.map = new window.TMap.Map(document.getElementById('container_map'), {
                center: new window.TMap.LatLng(25.05608, 102.696419),      // 地图的中心地理坐标。
                zoom: 12,  // 地图的中心地理坐标。
                viewMode:'2D',
                zoomControl: false,
                showControl: false,
                vectorBaseMap: {
                    type: 'vector',
                    features: []
                },
                mapStyleId: 'style1'
            });
            if (this.map) {
                this.getMyLocation();
            }
        },
        /** 
         *  腾讯ip定位获取坐标
         */
        // getForIP () {
        //     let _this = this;
        //     this.$jsonp(`https://apis.map.qq.com/ws/location/v1/ip`, {
        //         key: 'Z6HBZ-EUNLV-GQFP5-UZVBM-WR3PS-2XBMZ',
        //         output: 'jsonp'
        //     }).then(res => {
        //         console.log(res, '--res----');
        //         if (res.status == 0) {
        //             _this.latitude = res.result.location.lat;
        //             _this.longitude = res.result.location.lng;
        //         } else {
        //             // _this.getMyLocation();
        //         }
        //     })
        // },

        // CalcuMD5 (pwd) {
        //     const md5 = crypto.createHash('md5')
        //     md5.update(pwd);
        //     this.md5Value = md5.digest('hex')
        //     this.getForIP(this.md5Value);
        // },


        /** 
         *      组件定位坐标获取
         *      panTo: 将地图中心移动到指定的经纬度坐标。
         */
        getMyLocation () {
            console.log('--------')
            var geolocation = new window.qq.maps.Geolocation("SZMBZ-JCY6P-SKCDS-LFZGI-QC2B7-ZCFYN", "旅游资源信息管理平台");
            // geolocation.getIpLocation(this.showPosition, this.showErr);
            geolocation.getLocation(this.showPosition, this.showErr);//或者用getLocation精确度比较高
        },
        showPosition(position) {
            if (!this.map) return;
            this.latitude = position.lat;
            this.longitude = position.lng;
            this.city = position.city;
            if(position.lat) {
                this.map.panTo(new window.TMap.LatLng(this.latitude, this.longitude))
            }
        },
        showErr() {
            console.log("定位失败");
            this.getMyLocation();//定位失败再请求定位，测试使用
        },

        /**  
         * 清空地图上的点位信息
         */
        setMapAll () {
            if (this.markerList.length>0) {
                for(let i = 0; i < this.markerList.length; i++) {
                    this.markerList[i].setMap(null)
                }
            }
        },

        /**
         *   初始化地图函数  自定义函数名init
         */
        init() {
            this.setMapAll()
            if (!this.map) return;
            for (let i = 0; i < this.mapDataList.length; i++) {
                //创建一个Marker
                let marker = new window.TMap.MultiMarker({
                    id: this.mapDataList[i].id,
                    //设置显示Marker的地图  '/tio/touriIndustryManage
                    map: this.map,
                    styles: {
                        "marker": new window.TMap.MarkerStyle({
                            "width": 16,
                            "height": 16,
                            "anchor": { x: 10, y: 33 },
                            "src":  process.env.NODE_ENV === 'development' ?  this.mapDataList[i].img : `/web${this.mapDataList[i].img}`
                        })
                    },
                    geometries: [
                        {
                            "id": this.mapDataList[i].id,
                            "styleId": 'marker',
                            "position": new window.TMap.LatLng(this.mapDataList[i].lat, this.mapDataList[i].lng),
                            "properties": {
                                "title": "marker"
                            }
                        }
                    ]

                });
                this.markerList.push(marker);
                var infoWindow = new window.TMap.InfoWindow({
                    map: this.map,
                    position: new window.TMap.LatLng(this.mapDataList[i].lat, this.mapDataList[i].lng),
                    offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素
                });
                infoWindow.close();//初始关闭信息窗关闭
                //监听标注点击事件
                ((name) => {
                    const _this = this;
                    marker.on("click", function (evt) {
                        console.log(_this.flag, '圆点------:')
                        _this.flag = false;
                        _this.isShowItem = true;
                        infoWindow.open(); //打开信息窗
                        infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
                        infoWindow.setContent(`
                        <div style="white-space: normal; line-height: 18px; width: 100px">${name}</div>
                        <div style="position: absolute; background:#fff; right: 0px; top: 3px; width: 20px; height:20px;z-index: 9999;"></div>
                        `)
                    });
                })(this.mapDataList[i].monomerName)

            }

            this.map.on('click', (evt) => {
                console.log(this.flag, '空白-------:')
                if(this.flag){
                  this.isShowItem = !this.isShowItem;
                    infoWindow.close(); // 关闭信息窗
                } else {
                    this.isShowItem = false;
                    infoWindow.close(); // 关闭信息窗
                }
                this.flag = true;
            })

        },

        async getGrade (resolve) {
            let res = await api.getDirectoriesLevels();
            if (res.ret === 0) {
                let arr = res.data.map(item => {
                    return {
                        text: item.value,
                        value: item.code
                    }
                })
                let obj = {
                    text: '全部等级',
                    value: ''
                }
                arr = arr.sort(function(a, b){
                    let obj = ['五级', '四级', '三级', '二级', '一级']; 
                    return obj.indexOf(a.text) - obj.indexOf(b.text)
                })
                arr.unshift(obj);
                this.typeListGrade.push(arr);
            }
            resolve(true);
        },

        getGradeList () {
            return new Promise((resolve, reject) => {
                this.getGrade(resolve);
            })
        },

        /** 
         *  一级：10、二级：20、三级：30、四级：40、五级：50、未获等级：60）
         */
        async getDirectoriesPositions () {
            let res = await api.getDirectoriesPositions({ classifyId: this.classifyId, classifyLevel: this.classifyLevel, evaluateScoreLevel: this.evaluateScoreLevel });
            if (res.ret === 0) {
                this.mapDataList = [];
                let data = res.data;
                data.forEach(e => {
                    let arrBlue = e.mainClassifyCode === 'A' || e.mainClassifyCode === 'B' || e.mainClassifyCode === 'C' || e.mainClassifyCode === 'D';
                    let arrRed = e.mainClassifyCode === 'E' || e.mainClassifyCode === 'F' || e.mainClassifyCode === 'G' || e.mainClassifyCode === 'H';
                    if (arrBlue && e.evaluateScoreGrade === 50) {
                        e.img = '/mapIcon/ic_blue_5@2x.png'
                    } else if (arrRed && e.evaluateScoreGrade === 50) {
                        e.img = '/mapIcon/ic_red_5@2x.png'
                    } else if (arrBlue && e.evaluateScoreGrade === 40) {
                        e.img =  '/mapIcon/ic_blue_4@2x.png'
                    } else if (arrRed && e.evaluateScoreGrade === 40) {
                        e.img = '/mapIcon/ic_red_4@2x.png'
                    } else if (arrBlue && e.evaluateScoreGrade === 30) {
                        e.img = '/mapIcon/ic_blue_3@2x.png'
                    } else if (arrRed && e.evaluateScoreGrade === 30) {
                        e.img = '/mapIcon/ic_red_3@2x.png'
                    } else if (arrBlue && e.evaluateScoreGrade === 20) {
                        e.img = '/mapIcon/ic_blue_2@2x.png'
                    } else if (arrRed && e.evaluateScoreGrade === 20) {
                        e.img = '/mapIcon/ic_red_2@2x.png'
                    } else if (arrBlue && e.evaluateScoreGrade === 10) {
                        e.img =  '/mapIcon/ic_blue_1@2x.png'
                    } else if (arrRed && e.evaluateScoreGrade === 10) {
                        e.img =  '/mapIcon/ic_red_1@2x.png'
                    } else {
                        e.img = '/mapIcon/ic_1@2x.png'
                    }
                });
                this.mapDataList = data;
                this.init();
            }
        },
        checkArea () {
            this.$refs.commonpicker.showPicker();
        },
        getSelectArea (val) {
            if (val && val.length === 3) {
                if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text === '全部类型') {
                    this.selectArea = '全部类型';
                    this.classifyId = '';
                    this.classifyLevel = '';
                } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text !== '全部类型') {
                    this.selectArea = val[0].text;
                    this.classifyId = val[0].value;
                    this.classifyLevel = val[0].level;
                } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text !== '全部') {
                    this.selectArea = val[1].text;
                    this.classifyId = val[1].value;
                    this.classifyLevel = val[1].level;
                } else {
                    this.selectArea = val[2].text;
                    this.classifyId = val[2].value;
                    this.classifyLevel = val[2].level;
                }
            } else if (val && val.length === 2) {
                if (val[1].text === '全部') {
                    this.selectArea = val[0].text;
                    this.classifyId = val[0].value;
                    this.classifyLevel = val[0].level;
                    // this.classifyLevel = val[0].text === '全部' ? '1' : val[0].level;
                } else {
                    this.selectArea = val[1].text;
                    this.classifyId = val[1].value;
                    this.classifyLevel = val[1].level;
                }
            } else if (val && val.length === 1) {
                this.selectArea = val[0].text;
                this.classifyId = val[0].value;
                this.classifyLevel = val[0].level;
            }
            this.mapDataList = [];
            this.getDirectoriesPositions();
        },

        checkGrade () {
            this.$refs.commonpickerGrade.showPicker();
        },
        getSelectGrade (val) {
            this.selectGrade = val[0].text;
            this.evaluateScoreLevel = val[0].value;
            this.mapDataList = [];
            this.getDirectoriesPositions();
        },

        /** 
         *  地文景观
         */
        async getClassify (resolve) {
            let res = await api.getDirectoriesCodingClassify();
                if (res.ret === 0) {
                    let obj = {
                        text: '全部类型',
                        value: '',
                        shortName: '全部类型',
                        level: '',
                        children: [
                            {
                                text: '全部',
                                value: '',
                                shortName: '全部',
                                level: '',
                                children: [
                                    {
                                        text: '全部',
                                        value: '',
                                        shortName: '全部',
                                        level: '',
                                        
                                    }
                                ]
                            }
                        ]
                    }
                    let arr = res.data.map(item => {
                        return {
                            text: item.classifyName,
                            shortName: item.classifyName,
                            level: item.classifyLevel,
                            value: item.id,
                            pId: item.pId,
                            children: item.children.map(e => {
                                return {
                                    text: e.classifyName,
                                    shortName: e.classifyName,
                                    level: e.classifyLevel,
                                    value: e.id,
                                    pId: e.pId,
                                    children: e.children.map(el => {
                                        return {
                                            text: el.classifyName,
                                            shortName: el.classifyName,
                                            level: el.classifyLevel,
                                            value: el.id,
                                            pId: el.pId
                                        }
                                    })
                                }
                            })
                        }
                    })
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].children) {
                            let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                            let newArr = arr[i].children.concat([]);
                            arr[i].children = cityChild.concat(newArr)
                        }
                        for (var j = 0; j < arr[i].children.length; j++) {
                              if (arr[i].children[j].children) {
                                let cityChildren = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                                let newBrr = arr[i].children[j].children.concat([]);
                                arr[i].children[j].children = cityChildren.concat(newBrr)
                            }
                        }
                    }
                    arr.unshift(obj);
                    this.typeListCity = [];
                    this.typeListCity.push(arr);
                }
                resolve(true);
        },

        /** 
         *  地文景观 返回promise 重新处理
         */
        getPercentageClassify () {
            return new Promise((resolve, reject) => {
                this.getClassify(resolve);
            })
        }, 
    },
    beforeDestory () {
        if (this.map){
            this.map.destroy();
            this.map = null;
        }
    },
    destroyed () {
         if (this.map){
            this.map.destroy();
            this.map = null;
        }
    }
}
</script>

<style lang="less" scoped>
.distribution_wrap {
    background: #fbfbfb;
    .profile_area {
        padding: 12px;
        color: #fbfbfb;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        justify-content: left;
        align-items: center;
        .area_select {
            span {
                display: inline-block;
                padding-right: 5px;
                color: #4A4A4A;
            }
            img{
                display: inline-block;
                margin-left: 4px;
                width: 6px;
                height: 4px;
                vertical-align: middle;
            }
        }
        .area_select:nth-child(2) {
            margin-left: 24px;
        }
    }
    .distribution_map {
        /deep/.tmap-zoom-control {
            opacity: 0 ;
            z-index: -9999;
        }
        position: fixed;
        top: 88px;
        bottom: 0;
        width: 100%; 
        overflow: hidden;
        // height: 710px;
        .distribution_map_item {
            // width: 100%; 
            height: 100%;
        }
        .distribution_map_detail {
            position: fixed;
            bottom: 0;
            z-index: 99999;
            width: 100%;
            padding: 0 12px 18px 12px;
            .distribution_map_box {
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
                border-radius: 3px;
                background: #fff;
                padding: 16px;
                .distribution_map_detail_top {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    .distribution_map_detail_top_item {
                        display: flex;
                        color: #333;
                        font-size: 12px;
                        font-weight: 500;
                        span{
                            display: inline-block;
                            margin-top: 1px;
                        }
                        img{
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            margin-right: 4px;

                        }
                    }
                }
                .distribution_map_detail_bottom {
                    .distribution_map_detail_bottom_item:nth-child(1) {
                        margin-bottom: 16px;
                    }
                    .distribution_map_detail_bottom_item {
                        display: flex;
                        color: #333;
                        font-size: 12px;
                        font-weight: 500;
                        span{
                            display: inline-block;
                        }
                        img{
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            margin-right: 4px;
                        }
                    }
                }
            }
        }
    }
    /deep/.distribution_wrap .md-popup-mask {
        background-color: rgba(37, 38, 45, 0.3);
    }
    /deep/.md-popup-mask {
      background-color: rgba(37,38,45,.3);
    }
    /deep/.van-overlay {
      background-color: rgba(37,38,45,.3);
    }
}
</style>
<style lang="scss">
// .distribution_wrap .md-popup-mask {
//   background-color: rgba(37, 38, 45, 0.3);
// }
</style>
